import Vue from 'vue'

//
//	Global
//

Vue.filter('dynamicFilter', function(value, name, ...args) {
	return Vue.filter(name)(value, ...args);
});

//
// Strings
// 

Vue.filter('str_lower', function (value) {
	return value.toLowerCase()
});

Vue.filter('str_limit', function (value, size) {
	if (!value) return '';
	value = value.toString();

	if (value.length <= size) {
		return value;
	}
	return value.substr(0, size) + '...';
});

Vue.filter('ucfirst', function(value) {
	return value 
	? value[0].toUpperCase() + value.substring(1).toLowerCase()
	: ''
});

Vue.filter('capitalize', function(value) {
	return value 
	? _.startCase(_.toLower(value)) 
	: ''
});

Vue.filter('firstname', function(value) {

	if(!value) return;	

		// Default
		value = Vue.filter('ucfirst')(value)

		// Case : -
		value = value.split('-');

		if(value[1]) {
			value.forEach((word, i) => {
				value[i] = Vue.filter('ucfirst')(word)
			});
		}
		
		value = value.join('-');


		// Case : ' '
		value = value.split(' ');

		if(value[1]) {
			value.forEach((word, i) => {
				if(word)
					value[i] = word[0].toUpperCase() + word.substring(1)
			});
		}

		value = value.join(' ');

		return value;
	})

Vue.filter('slugify', function(value) {
  value = value.replace(/^\s+|\s+$/g, ''); // trim
  value = value.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;\'";
  var to   = "aaaaaeeeeeiiiiooooouuuunc-------";
  for (var i=0, l=from.length ; i<l ; i++) {
  	value = value.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  value = value.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '_') // collapse whitespace and replace by -
    .replace(/-+/g, '_'); // collapse dashes

    return value;
});


//
// Dates
//

Vue.filter('date', function (value, format = 'DD-MM-YYYY') {
	return moment(value).format(format)
});

Vue.filter('price', function (value) {
	return new Intl.NumberFormat(
		'fr-FR', { 
			style: 'currency', currency: 'EUR' 
		}
	).format(value)
});

Vue.filter('timestamp', function(value) {
	return moment(value).format('DD MMMM Y à HH:mm')
})

Vue.filter('dateFromNow', function(value) {
	return Vue.filter('ucfirst')(moment(value).fromNow());
})